// extracted by mini-css-extract-plugin
export var actionIcon = "_qx-0";